import type { QueueStore } from "~~/types/#app";

const getQueueStore = (): QueueStore => {

  const nuxtApp = useNuxtApp();

  if (!nuxtApp._promiseQueueStore) {

    nuxtApp._promiseQueueStore = new Map<string, Promise<unknown>>();

  }

  return nuxtApp._promiseQueueStore;

};

type AsyncFunction<Args extends unknown[], Result> = (...args: Args) => Promise<Result>;

export const usePromiseQueue = <Args extends unknown[], Result>(
  func: AsyncFunction<Args, Result>,
  cachingKey: string,
) => {

  const queueStore = getQueueStore();

  const execute = (...args: Args): Promise<Result> => {

    const currentPromise = queueStore.get(cachingKey) ?? Promise.resolve();

    const newPromise = currentPromise
      .catch(() => undefined)
      .then(() => func(...args))
      .finally(() => {

        const latest = queueStore.get(cachingKey);

        if (latest === newPromise) {

          queueStore.set(cachingKey, Promise.resolve());

        }

      });

    queueStore.set(cachingKey, newPromise.catch(() => Promise.resolve()));

    return newPromise;

  };

  return {
    execute,

  };

};

